import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Card, Col, Container, Input, Row } from 'reactstrap'

import { NormCard } from './NormCard'
import { PdfModal } from './PdfModal'
import { NewNormModal } from './NewNormModal'
import Breadcrumb from '../../components/Common/Breadcrumb'
import Table1 from '../../components/Common/TableContainer'
import { BackButton } from '../../components/Common/BackButton'
import { TableItemDeleteModal } from '../../components/Common/TableItemDeleteModal'
import { AnalysisRequestNewRegisterButton } from '../../components/Common/AnalysisRequestNewRegisterButton'
import { addNewNormsLibrary, deleteNormsLibrary, getNorms, getNormsLibrarys, updateNormsLibrary } from '../../store/actions'
import { ToastContainer } from 'react-toastify'
import "react-toastify/dist/ReactToastify.css"
import { BaseSelectComponent, BaseCustomButton } from '../../shared'

export const NormLibrary = (props) => {

    const [showModal1, setShowModal1] = useState(false);

    const [showModalPDF, setShowModalPDF] = useState(false);

    const [showInfo, setShowInfo] = useState(false);

    const [rowInfo, setRowInfo] = useState();

    const [isUpdate, setIsUpdate] = useState(false);

    const [showModalDeleteItem, setShowModalDeleteItem] = useState(false);

    const [normSearch, setNormSearch] = useState('');
    const [normSearchURL, setNormSearchURL] = useState('');

    const [startDateSearch, setStartDateSearch] = useState('');
    const [startDateSearchURL, setStartDateSearchURL] = useState('');

    const [finalDateSearch, setFinalDateSearch] = useState('');
    const [finalDateSearchURL, setFinalDateSearchURL] = useState('');

    const role = (localStorage.getItem("authUser")) ?  JSON.parse(localStorage.getItem("authUser"))?.role : ''

    const [normaSelected, setNormaSelected] = useState(''); // Store selected Norma

    // * Redux
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getNormsLibrarys(`?limit=20&page=0`));
        dispatch(getNorms("?limit=100000&page=0"));

        setNormSearch('');
        setNormSearchURL('');

        setStartDateSearch('');
        setStartDateSearchURL('');

        setFinalDateSearch('');
        setFinalDateSearchURL('');
    }, [])

    const { normsLibrarys, loading, total, currentPage, norms } = useSelector(state => ({
        normsLibrarys: state.normLibraryReducer.normsLibrarys,
        loading: state.normLibraryReducer.loading,
        normsLibrary: state.normLibraryReducer.normsLibrary,
        norms: state.norms.norms,
        total: state.normLibraryReducer.total,
        currentPage: state.normLibraryReducer.currentPage,
    }));
    // * Redux fin


    const data2 = normsLibrarys.map((norm, index) => (
        {
            ...norm,
            file: (norm.file).replace('/usr/src/app/static/uploads/', ''),
            datedAt: norm.datedAt ? norm.datedAt.substring(0, 10) : '',
        }
    ))

    useEffect(() => {

        if (normSearch !== '' && normSearch !== undefined && normSearch !== null) {
            setNormSearchURL(`&norm=${normSearch?.id}`);
        } else { setNormSearchURL(''); }

        if (startDateSearch !== '') {
            setStartDateSearchURL(`&initialDatedAt=${startDateSearch}`);
        } else { setStartDateSearchURL(''); }

        if (finalDateSearch !== '') {
            setFinalDateSearchURL(`&finalDatedAt=${finalDateSearch}`);
        } else { setFinalDateSearchURL(''); }

    }, [normSearch, startDateSearch, finalDateSearch, normaSelected])


    const modalRespInfo = (values) => {
        if (isUpdate) {
            const updValue = { ...values, id: rowInfo.id };
            if (values.file != null) {
                dispatch(updateNormsLibrary(updValue));
            } else {
                dispatch(updateNormsLibrary({
                    id: rowInfo.id,
                    status: rowInfo.status,
                    norm: values.norm,
                    normType: values.normType,
                    description: values.description,
                    datedAt: values.datedAt,
                    password: values.password,
                }));
            }
            dispatch(getNormsLibrarys(`?limit=20&page=0`));
        } else {
            const postValues = { ...values, status: 'Activo', isPostingFile: 'isPostingFile'}
            dispatch(addNewNormsLibrary(postValues));
        }
        setIsUpdate(false);
        setRowInfo('');
    }

    const onUpdate = (values) => {
        setRowInfo(values);
        setIsUpdate(true);
        setShowModal1(true);
    }

    const onDelete = (values) => {
        setRowInfo(values);
        setShowModalDeleteItem(true);
    }

    const onDeleteConfirmation = () => {
        dispatch(deleteNormsLibrary(rowInfo));
        setRowInfo('');
    }

    const getPagination = (params) => {
        dispatch(getNormsLibrarys(`${params}${normSearchURL}${startDateSearchURL}${finalDateSearchURL}`));
    }

    const modalClose = () => {
        setIsUpdate(false);
    }

    const onPDF = (values) => {
        setRowInfo(values);
        setShowModalPDF(true);
    }

    const onNormSearchChange = (selectedOption) => {
        setNormSearch(selectedOption ? selectedOption : null); 
    }      

    const onStartDateSearchChange = (event) => {
        setStartDateSearch(event.target.value);
    }

    const onFinalDateSearchChange = (event) => {
        setFinalDateSearch(event.target.value);
    }

    const onHandleSearch = () => {
        const normParam = normSearch ? `&norm=${normSearch.value}` : ''; 
        dispatch(getNormsLibrarys(`?limit=20&page=0${normParam}${startDateSearchURL}${finalDateSearchURL}`));
     }      

    const columns = React.useMemo(
        () => [
            {
                Header: 'Nombre de la Norma',
                width: '20%',
                Cell: ({ row }) => (
                    <div>
                        <span><strong>{row.original.norm.name ?? '-'}</strong></span>
                    </div>
                ),
            },
            {
                Header: 'Información General',
                width: '25%',
                Cell: ({ row }) => (
                    <div>
                        <span><strong>Tipo de Norma: </strong></span> <span className='text-primary'>{row.original.normType ?? '-'}</span>
                        <hr className='m-0 mb-1' style={{ height: 1 }} />
                        <span><strong>Detalles de la Norma: </strong></span> <span className='text-primary'> {row.original.description ?? '-'}</span>
                    </div>
                ),
            },
            {
                Header: 'Contraseña',
                width: '10%',
                Cell: ({ row }) => (
                    <div>
                        <span className='text-primary'>{row?.original?.password ?? '-'}</span>
                    </div>
                ),
            },
            {
                Header: 'Vigencia',
                accessor: 'datedAt',
                width: '15%',
            },
            {
                width: '10%',
                Header: "Acciones",
                Cell: ({ row }) => (
                    <div className="row g-1">
                        
                        <BaseCustomButton
                            color='primary'
                            className='col-12 col-sm-6 col-lg-12'
                            onClick={() => { onPDF(row.original) }}
                            label='PDF'
                            outline={true}
                            icon="mdi mdi-file-pdf"
                        />

                        <BaseCustomButton
                            color='success'
                            className='col-12 col-sm-6 col-lg-12'
                            onClick={() => { onUpdate(row.original) }}
                            label='Editar'
                            outline={true}
                            icon="mdi mdi-lead-pencil"
                            disabled={(role === 'Laboratorista') || (role === 'Asesor Técnico')}
                        />

                        <BaseCustomButton
                            color='danger'
                            className='col-12 col-sm-6 col-lg-12'
                            onClick={() => { onDelete(row.original) }}
                            label='Eliminar'
                            outline={true}
                            icon="mdi mdi-delete"
                            disabled={(role === 'Laboratorista') || (role === 'Asesor Técnico')} 
                        />

                    </div>
                ),
            },
        ],
        []
    )

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid className="" >
                    <Col className="col-12" style={{ padding: 20 }}>
                        <Card className='' style={{ padding: 50 }}>

                            <div className="d-flex align-items-center justify-content-between">
                                <Breadcrumb breadcrumbItem1='normLibrary' />
                                <BackButton props={props} />
                            </div>

                            <Card className='' style={{ padding: 20 }}>

                                <div className='d-flex align-items-end justify-content-between mt-0 pt-0 mb-2 ms-2'>

                                    <div className='w-100 me-3'>
                                        <label className='text-primary'>Norma</label>
                                        <BaseSelectComponent
                                            options={norms.map(norm => ({ value: norm.id, label: norm.name }))}
                                            value={normaSelected}
                                            onChangeAsObject={true}
                                            onChange={onNormSearchChange}
                                            placeholder="Seleccionar Norma"
                                        />
                                    </div>

                                    <BaseCustomButton
                                        color="dark"
                                        className="py-2 rounded-3 w-25 me-3"
                                        icon="mdi-magnify"
                                        label="Buscar"
                                        onClick={onHandleSearch}
                                    />
                                </div>

                                <div className="d-flex align-items-end justify-content-between px-0 ms-2">

                                    <div className='w-100 me-3'>
                                        <label htmlFor="exampleInputEmail1" className='text-primary'>Fecha Inicio</label>
                                        <Input
                                            name="datetime1"
                                            className="form-control rounded-3 text-primary"
                                            type='date'
                                            onChange={onStartDateSearchChange}
                                        />
                                    </div>

                                    <div className='w-100 me-3'>
                                        <label htmlFor="exampleInputEmail1" className='text-primary'>Fecha Fin</label>
                                        <Input
                                            name="datetime2"
                                            className="form-control rounded-3 text-primary"
                                            type='date'
                                            onChange={onFinalDateSearchChange}
                                        />
                                    </div>

                                    <BaseCustomButton
                                    color="info"
                                    className="py-1 d-flex align-items-center justify-content-center w-25 me-2"
                                    icon="mdi-18px mdi-table"
                                    label={showInfo ? 'Vista Normas' : 'Tabla'}
                                    onClick={() => setShowInfo(!showInfo)}
                                    />

                                    <div className='w-25'>
                                        <AnalysisRequestNewRegisterButton disabled={(role === 'Laboratorista')} showModal={showModal1} setShowModal={setShowModal1} text={'Nueva Norma'} />
                                        <NewNormModal props={props} showModal={showModal1} setShowModal={setShowModal1} modalRespInfo={modalRespInfo} modalHeader='Registro de Normas' modalClose={modalClose} isUpdate={isUpdate} rowInfo={rowInfo} norms={norms} />
                                    </div>

                                </div>

                                <hr className='text-primary' />

                                <label className='text-info px-2'>Publicación de normas</label>

                                {
                                    showInfo
                                        ?
                                        <Row>
                                            {normsLibrarys.map((data, index) => <NormCard key={index} data={data} props={props} />)}
                                        </Row>
                                        :
                                        <>
                                            <Table1 currentPage={currentPage} getPagination={getPagination} total={total} loading={loading} isAddTableBorderStrap columns={columns} data={data2} />
                                            <TableItemDeleteModal props={props} onDeleteConfirmation={onDeleteConfirmation} setShowModal={setShowModalDeleteItem} showModal={showModalDeleteItem} modalHeader='Eliminar Norma' modalBodyLabel='¿Está seguro que desea borrar la norma seleccionada?' />
                                            {
                                                showModalPDF
                                                    ? <PdfModal props={props} setShowModal={setShowModalPDF} showModal={showModalPDF} rowInfo={rowInfo.file} />
                                                    : ''
                                            }
                                        </>
                                }

                            </Card>

                            <br />
                            <br />

                        </Card>
                    </Col>
                    <ToastContainer autoClose={2000} newestOnTop={true} />
                </Container>
            </div>
        </React.Fragment>
    )
}
